<script setup lang="ts">
import { onMounted, ref, reactive, Ref } from "vue";
import Link from '@/views/components/Link.vue'

// Props
const props = defineProps<{
  currentPage: number;
  count: number;
  itemsPerPage: number;
  path: string;
  query: any;
}>();

// Refs
const totalNumberOfPages: Ref<number | null> = ref(null);

// Lifecycle Hooks
onMounted(() => {
  // totalNumberOfPages.value = Math.floor(props.count / props.itemsPerPage);
  totalNumberOfPages.value = Math.ceil(props.count / props.itemsPerPage);

  if (props.query.dep) {
    // @ts-ignore
    query.dep = props.query.dep;
  }

  if (props.query.keyword) {
    // @ts-ignore
    query.keyword = props.query.keyword;
  }

  if (props.query.code) {
    // @ts-ignore
    query.code = props.query.code;
  }

  if (props.query.town) {
    // @ts-ignore
    query.town = props.query.town;
  }
});

// Reactive variables
const query = reactive({});

// Functions
const range = (start: number, end: number) => {
  let list = [];
  for (let i = start; i <= end; i++) {
    list.push(i);
  }

  return list;
};

const routeTo = (page: any) => {
  let query_string = '?page=' + page

  Object.entries(query).forEach((item, index) => {
    if (index == 0) {
      query_string += `${item[0]}=${item[1]}`
    } else {
      query_string += `&${item[0]}=${item[1]}`
    }
  })

  // console.log("query_string from paginator", query_string)
  // console.log(`${props.path}/${query_string}`)

  return `${props.path}/${query_string}`
};
</script>

<template>
  <div>
    <nav aria-label="Page navigation">
      <template v-if="totalNumberOfPages && totalNumberOfPages <= 7">
        <ul class="pagination justify-content-center mt-2">
          <li v-if="currentPage !== 1" class="page-item prev-item">
            <Link
              :href="routeTo(currentPage - 1)"
              class="page-link"
            ></Link>
          </li>
          <template v-for="pageLink in totalNumberOfPages">
            <li v-if="pageLink !== currentPage" class="page-item">
              <Link :href="routeTo(pageLink)" class="page-link">{{
                pageLink
              }}</Link>
            </li>
            <li v-else class="page-item active" aria-current="page">
              <Link :to="routeTo(pageLink)" class="page-link">{{
                pageLink
              }}</Link>
            </li>
          </template>
        </ul>
      </template>
      <template
        v-if="totalNumberOfPages && totalNumberOfPages > 7 && currentPage < 5"
      >
        <ul class="pagination justify-content-center mt-2">
          <li v-if="currentPage !== 1" class="page-item prev-item">
            <Link
              :href="routeTo(currentPage - 1)"
              class="page-link"
            ></Link>
          </li>
          <template v-for="pageLink in range(1, 5)">
            <li v-if="pageLink !== currentPage" class="page-item">
              <Link :href="routeTo(pageLink)" class="page-link">{{
                pageLink
              }}</Link>
            </li>
            <li v-else class="page-item active" aria-current="page">
              <Link :href="routeTo(pageLink)" class="page-link">{{
                pageLink
              }}</Link>
            </li>
          </template>
          <li class="page-item">&nbsp;&nbsp;....&nbsp;&nbsp;</li>
          <li class="page-item">
            <Link :href="routeTo(totalNumberOfPages)" class="page-link">{{
              totalNumberOfPages
            }}</Link>
          </li>
          <li class="page-item next-item">
            <Link
              :href="routeTo(currentPage + 1)"
              class="page-link"
            ></Link>
          </li>
        </ul>
      </template>
      <template
        v-if="totalNumberOfPages && totalNumberOfPages > 7 && currentPage >= 5"
      >
        <template v-if="totalNumberOfPages - currentPage > 3">
          <ul class="pagination justify-content-center mt-2">
            <li v-if="currentPage !== 1" class="page-item prev-item">
              <Link
                :href="routeTo(currentPage - 1)"
                class="page-link"
              ></Link>
            </li>
            <li class="page-item">
              <Link :href="routeTo(1)" class="page-link">1</Link>
            </li>
            <li class="page-item">&nbsp;&nbsp;....&nbsp;&nbsp;</li>
            <li class="page-item">
              <Link :href="routeTo(currentPage - 1)" class="page-link">{{
                currentPage - 1
              }}</Link>
            </li>
            <li class="page-item active" aria-current="page">
              <Link :href="routeTo(currentPage)" class="page-link">{{
                currentPage
              }}</Link>
            </li>
            <li class="page-item">
              <Link :href="routeTo(currentPage + 1)" class="page-link">{{
                currentPage + 1
              }}</Link>
            </li>
            <li class="page-item">&nbsp;&nbsp;....&nbsp;&nbsp;</li>
            <li class="page-item">
              <Link
                :href="routeTo(totalNumberOfPages)"
                class="page-link"
                >{{ totalNumberOfPages }}</Link
              >
            </li>
            <li class="page-item next-item">
              <Link
                :href="routeTo(currentPage + 1)"
                class="page-link"
              ></Link>
            </li>
          </ul>
        </template>
        <template v-else>
          <ul
            v-if="currentPage !== totalNumberOfPages"
            class="pagination justify-content-center mt-2"
          >
            <li v-if="currentPage !== 1" class="page-item prev-item">
              <Link
                :href="routeTo(currentPage - 1)"
                class="page-link"
              ></Link>
            </li>
            <li class="page-item">
              <Link :href="routeTo(1)" class="page-link">1</Link>
            </li>
            <li class="page-item">&nbsp;&nbsp;....&nbsp;&nbsp;</li>
            <template
              v-for="pageLink in range(currentPage - 1, totalNumberOfPages)"
            >
              <li v-if="pageLink !== currentPage" class="page-item">
                <Link :href="routeTo(pageLink)" class="page-link">{{
                  pageLink
                }}</Link>
              </li>
              <li v-else class="page-item active" aria-current="page">
                <Link :href="routeTo(pageLink)" class="page-link">{{
                  pageLink
                }}</Link>
              </li>
            </template>
            <li
              v-if="currentPage !== totalNumberOfPages"
              class="page-item next-item"
            >
              <Link
                :href="routeTo(currentPage + 1)"
                class="page-link"
              ></Link>
            </li>
          </ul>
          <ul v-else class="pagination justify-content-center mt-2">
            <li v-if="currentPage !== 1" class="page-item prev-item">
              <Link
                :href="routeTo(currentPage - 1)"
                class="page-link"
              ></Link>
            </li>
            <li class="page-item">
              <Link :href="routeTo(1)" class="page-link">1</Link>
            </li>
            <li class="page-item">&nbsp;&nbsp;....&nbsp;&nbsp;</li>
            <template
              v-for="pageLink in range(currentPage - 3, totalNumberOfPages)"
            >
              <li v-if="pageLink !== currentPage" class="page-item">
                <Link :href="routeTo(pageLink)" class="page-link">{{
                  pageLink
                }}</Link>
              </li>
              <li v-else class="page-item active" aria-current="page">
                <Link :href="routeTo(pageLink)" class="page-link">{{
                  pageLink
                }}</Link>
              </li>
            </template>
            <li
              v-if="currentPage !== totalNumberOfPages"
              class="page-item next-item"
            >
              <Link
                :href="routeTo(currentPage + 1)"
                class="page-link"
              ></Link>
            </li>
          </ul>
        </template>
      </template>
    </nav>
  </div>
</template>

<style scoped>
@import url("@/assets/css/bootstrap-extended.css");
</style>
